import { spacing } from '$tablet-app/src/app/theme';
import React, { useState } from 'react';
import {
  Image,
  ImageSourcePropType,
  LayoutChangeEvent,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';

type Props = {
  profileColor: string;
  source: ImageSourcePropType;

  style?: StyleProp<ViewStyle>;
};

const SelectedProfileImage = (props: Props) => {
  const { profileColor, source, style } = props;

  const [size, setSize] = useState(240);

  const handleContainerLayout = (event: LayoutChangeEvent) => {
    const { width, height } = event.nativeEvent.layout;
    setSize(Math.min(width, height));
  };

  const imageSize = size - 2 * spacing[4];

  return (
    <View
      style={[styles.containerStyle, style]}
      onLayout={handleContainerLayout}
    >
      <View
        style={[
          styles.profileImageBorder,
          {
            width: size,
            height: size,
            borderRadius: size / 2,
            borderColor: profileColor,
          },
        ]}
      >
        <Image
          style={[
            styles.profileImage,
            {
              width: imageSize,
              height: imageSize,
              borderRadius: imageSize / 2,
            },
          ]}
          source={source}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  containerStyle: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileImage: {
    overflow: 'hidden',
  },
  profileImageBorder: {
    borderWidth: 8,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default SelectedProfileImage;
